import Inspector from './inspector';
const { RichText } = wp.blockEditor;

const staticDefaultImage = 'https://via.placeholder.com/80?text=Icon';

const Edit = ({ attributes, setAttributes }) => {
  const {
    descriptionCard,
    numberCard,
    textCard,
    icon,
    cardHasImg,
    cardHasDescription,
    background,
    variant,
  } = attributes;

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <div
        className={`ColorCardsItem ${variant} ${
          variant === 'text-inside' ? background : ''
        }`}
      >
        <a className={`ColorCardsItem__card`}>
          <div
            className={`ColorCardsItem__card--content ${
              variant === 'text-outside' ? background : ''
            }`}
          >
            {cardHasImg ? (
              <figure className="ColorCardsItem__card--icon">
                <img src={icon.src || staticDefaultImage} />
              </figure>
            ) : (
              <div className="ColorCardsItem__card--text">
                <RichText
                  tagName="p"
                  selector="p"
                  className="ColorCardsItem__card--number"
                  value={numberCard}
                  placeholder="Número do card"
                  keepPlaceholderOnFocus
                  onChange={(numberCard) => setAttributes({ numberCard })}
                />

                <RichText
                  tagName="p"
                  selector="p"
                  className="ColorCardsItem__card--underNumber"
                  value={textCard}
                  placeholder="Texto card"
                  keepPlaceholderOnFocus
                  onChange={(textCard) => setAttributes({ textCard })}
                />
              </div>
            )}
          </div>

          {cardHasDescription && (
            <RichText
              tagName="p"
              selector="p"
              className={`ColorCardsItem__card--description Typography subtitle color-blue center margin-none`}
              value={descriptionCard}
              placeholder="Descrição Card"
              keepPlaceholderOnFocus
              onChange={(descriptionCard) => setAttributes({ descriptionCard })}
            />
          )}
        </a>
      </div>
    </>
  );
};

export default Edit;
